// initial state
const state = {
  display: false,
  message: null
}

// getters
const getters = {
  getMessage: state => state.message,
  isDisplay: state => state.display
}

// mutations
const mutations = {
  setDisplay: (state, payload) => state.display = payload,
  setMessage: (state, payload) => state.message = payload
}

// actions
const actions = {
  setDisplay: ({ commit }, payload) => commit('setDisplay', payload),
  setMessage: ({ commit }, payload) => commit('setMessage', payload)
}

// export variables with namespaced
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
